import { Radio, useImageUrlChecker } from '@anyonelab/common/'
import { apiClient } from '@anyonelab/frontend/utils/api-client'
import React from 'react'
import { useIntl } from 'react-intl'
import messages from '../messages'
import DefaultBobaThankYouImage from '../../../assets/boba-thank-you-animation.gif'
import styled from 'styled-components'
import { message, Spin } from 'antd'

export const ThankYouImageRadioGroup = ({ updateOnClick, imageUrl }) => {
  const inputFile = React.useRef<HTMLInputElement | null>(null)
  const [isWaitingImageUpload, setIsWaitingImageUpload] = React.useState(false)
  const { isWaitingThumbnail } = useImageUrlChecker(imageUrl)
  const intl = useIntl()

  return (
    <>
      <input
        ref={inputFile}
        name="thank_you_image_url"
        type="file"
        accept=".jpg,.jpeg,.png"
        style={{ display: 'none' }}
        onChange={async (e) => {
          if (!e.target || !e.target.files || e.target.files.length === 0)
            return

          setIsWaitingImageUpload(true)
          try {
            const formData = new FormData()
            formData.append('uri', e.target.files[0])
            const response = await apiClient.post(
              `/image-upload?type=bobaThankYouImage`,
              formData,
            )

            updateOnClick({
              thank_you_image_url: response.data.image_name,
            })

            setIsWaitingImageUpload(false)
          } catch (err) {
            console.error(err)
            setIsWaitingImageUpload(false)
            message.error(intl.formatMessage(messages.uploadFailed))
          }
        }}
      />
      <StyledRadio value={true}>
        <div>{intl.formatMessage(messages.default)}</div>
        <div
          style={{
            width: '120px',
            height: '76px',
            borderRadius: '10px',
            backgroundColor: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '4px',
          }}
        >
          <img
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            src={DefaultBobaThankYouImage}
            alt="default-thank-you-gif"
          />
        </div>
      </StyledRadio>
      <StyledRadio value={false}>
        <div>{intl.formatMessage(messages.yourPic)}</div>
        <div
          onClick={() => {
            if (inputFile && inputFile.current) {
              inputFile.current.click()
            }
          }}
          style={{
            cursor: 'pointer',
            width: '120px',
            height: '76px',
            borderRadius: '10px',
            backgroundColor: '#E4E4E4',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '4px',
          }}
        >
          {isWaitingImageUpload ? (
            <Spin />
          ) : !imageUrl ? (
            <div className="text">
              {intl.formatMessage(messages.imageLimit, { br: <br /> })}
            </div>
          ) : (
            <img
              src={
                isWaitingThumbnail
                  ? imageUrl.replace('thumbnail', 'original')
                  : imageUrl
              }
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '10px',
              }}
              alt="thank you message"
            />
          )}
        </div>
      </StyledRadio>
    </>
  )
}

const StyledRadio = styled(Radio)`
  margin: 0px 16px;

  .ant-radio-inner:after {
    background: #ad5138 !important;
  }

  .ant-radio-checked .ant-radio-inner,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-wrapper:hover,
  .ant-radio-input:focus .ant-radio-inner {
    border-color: #ad5138 !important;
  }

  .text {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    letter-spacing: 0.04em;
    color: #9f9f9f;
  }

  .ant-radio-checked::after {
    border: 1px solid #ad5138;
  }
`
